interface ContactBubbleModalProps {
  open: boolean;
  onClose: () => void;
}

export default function ContactBubbleModal({ open, onClose }: ContactBubbleModalProps) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center"
      style={{ backgroundColor: 'rgba(21, 20, 20, 0.4)', backdropFilter: 'blur(6px)' }}
      onClick={onClose}
    >
      {/* Bubble container */}
      <div
        className="relative mx-4"
        style={{
          maxWidth: '380px',
          width: '100%',
          animation: 'bubble-pop 0.4s cubic-bezier(0.34, 1.56, 0.64, 1)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Bubble body */}
        <div
          style={{
            backgroundColor: '#faf6f0',
            borderRadius: '24px 24px 24px 4px',
            boxShadow: '0 20px 60px rgba(0,0,0,0.15), 0 0 0 1px rgba(200, 170, 130, 0.15)',
            padding: '36px 32px 28px',
            position: 'relative',
          }}
        >
          {/* Close */}
          <button
            onClick={onClose}
            className="absolute transition-all duration-200 hover:scale-110 hover:rotate-90"
            style={{
              top: '14px',
              right: '14px',
              width: '28px',
              height: '28px',
              borderRadius: '50%',
              border: '1px solid rgba(200, 170, 130, 0.2)',
              backgroundColor: 'transparent',
              color: '#a08e78',
              fontSize: '0.85rem',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            ✕
          </button>

          {/* Title */}
          <div className="text-center mb-5">
            <div className="flex items-center justify-center gap-2 mb-2">
              <div style={{ width: '4px', height: '4px', borderRadius: '50%', backgroundColor: '#e8a838' }} />
              <div style={{ width: '4px', height: '4px', borderRadius: '50%', backgroundColor: '#e8a838', opacity: 0.5 }} />
              <div style={{ width: '4px', height: '4px', borderRadius: '50%', backgroundColor: '#e8a838', opacity: 0.3 }} />
            </div>
            <p
              style={{
                fontSize: '1.1rem',
                color: '#5a4a3a',
                fontWeight: 500,
                letterSpacing: '0.08em',
              }}
            >
              联系我们
            </p>
          </div>

          {/* Phone */}
          <div
            className="flex items-center gap-3 mb-5 p-4"
            style={{
              backgroundColor: 'rgba(232, 168, 56, 0.06)',
              borderRadius: '16px',
              border: '1px solid rgba(232, 168, 56, 0.12)',
            }}
          >
            <div
              className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center"
              style={{ backgroundColor: 'rgba(232, 168, 56, 0.12)' }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#e8a838" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
            </div>
            <div>
              <p style={{ fontSize: '0.68rem', color: '#8a7a68', marginBottom: '2px' }}>服务热线</p>
              <p style={{ fontSize: '1.05rem', color: '#5a4a3a', fontWeight: 600, letterSpacing: '0.04em' }}>
                021 62160968
              </p>
            </div>
          </div>

          {/* QR Code */}
          <div className="text-center">
            <p style={{ fontSize: '0.7rem', color: '#8a7a68', marginBottom: '8px' }}>企业微信客服</p>
            <div
              className="inline-block p-2.5"
              style={{
                backgroundColor: '#fff',
                borderRadius: '12px',
                border: '1px solid rgba(200, 170, 130, 0.15)',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
              }}
            >
              <img
                src="/images/customer-service-qr.png"
                alt="企业微信客服二维码"
                style={{ width: '140px', height: '140px', display: 'block', borderRadius: '8px' }}
              />
            </div>
            <p style={{ fontSize: '0.65rem', color: 'rgba(110, 94, 80, 0.4)', marginTop: '6px' }}>
              扫码咨询客服
            </p>
          </div>

          {/* Tail triangle */}
          <div
            className="absolute"
            style={{
              bottom: '-10px',
              left: '36px',
              width: '20px',
              height: '20px',
              backgroundColor: '#faf6f0',
              transform: 'rotate(45deg)',
              borderRadius: '0 0 4px 0',
            }}
          />
        </div>
      </div>

      <style>{`
        @keyframes bubble-pop {
          0% { transform: scale(0.7) translateY(20px); opacity: 0; }
          100% { transform: scale(1) translateY(0); opacity: 1; }
        }
      `}</style>
    </div>
  );
}
